import { type ReactElement, useContext } from "react";
import { ActivityAnimationContext } from "../ActivityAnimationContext";
import { Icon, type IconName } from "../Icon";
import { PulsingIcon } from "../PulsingIcon";
import { ShimmerSpan } from "../ShimmerSpan";
import { Text } from "../Text";
import { TypewriterSpan } from "../TypewriterSpan";

type Props = {
  icon: IconName | ReactElement;
  text: string;
  pending?: boolean;
  iconColor?: string;
};

export function ToolStatus({
  icon,
  text,
  pending = false,
  iconColor = "var(--text-secondary)",
}: Props) {
  // Keep live activity animated between tool completions, while standalone rows follow their own pending state.
  const animated = useContext(ActivityAnimationContext)?.live ?? pending;
  return (
    <>
      <PulsingIcon data-pending={animated}>
        {typeof icon === "string" ? (
          <Icon name={icon} size={12} color={iconColor} />
        ) : (
          icon
        )}
      </PulsingIcon>
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        <ShimmerSpan data-pending={animated}>
          <TypewriterSpan>{text}</TypewriterSpan>
        </ShimmerSpan>
      </Text>
    </>
  );
}
